import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, ResetPasswordPayload } from './types'
import { EMPTY_STRING, HTTP_STATUS } from 'lib/core/resources/constants'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/resetPassword',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<ResetPasswordPayload>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

interface ResetPasswordDeps {
  resetToken: string
  newPassword: string
}

export function resetPassword (payload: ResetPasswordDeps): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())

    try {
      const response = await magentoClient.getClient().customer.resetPassword({
        payload: {
          email: EMPTY_STRING,
          ...payload
        }
      })
      const { data, status } = response
      if (status === HTTP_STATUS.OK) {
        dispatch(success(data))
      } else {
        dispatch(failure())
      }
      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
